import { all, call, put, takeLatest } from '@redux-saga/core/effects';
import i18next from 'i18next';
import { SETTINGS_FETCH } from '../actions/settings/settingsActionConstants';
import {
  setSettings,
  setSettingsError,
} from '../actions/settings/settingsActions';
import { getSettingsRequest } from '../../request/settingsRequests';

function* fetchSettings() {
  try {
    const { data } = yield call(getSettingsRequest);
    yield put(setSettings(data));
  } catch (e) {
    const errorCode = e.ErrorCodeType || e.message.replace(' ', '');
    const errorMessage = i18next.t(`apiErrors.${errorCode}`);
    yield put(setSettingsError(errorMessage));
  }
}

export default function* settingsSaga() {
  yield all([takeLatest(SETTINGS_FETCH, fetchSettings)]);
}
